module.exports = __webpack_public_path__ + "static/media/basket_wars.7be2f779.JPG";